// Mock data for FormForgePro application

export const legalServices = [
  // Family Law Services
  {
    id: 1,
    category: "Family Law",
    title: "Uncontested Divorce",
    description: "Complete divorce paperwork for uncontested cases with no children or minimal assets",
    price: 99,
    duration: "15-20 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Heart",
    features: ["Petition for Divorce", "Property Settlement Agreement", "Final Decree", "Filing Instructions"]
  },
  {
    id: 2,
    category: "Family Law", 
    title: "Child Custody Agreement",
    description: "Legal custody and visitation agreements that protect your children's best interests",
    price: 129,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "Users",
    features: ["Custody Agreement", "Visitation Schedule", "Child Support Guidelines", "Modification Forms"]
  },
  {
    id: 3,
    category: "Family Law",
    title: "Child Support Calculation",
    description: "Calculate and file proper child support forms with state-specific guidelines",
    price: 89,
    duration: "15-20 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "Users",
    features: ["Support Calculation Worksheet", "Income Documentation", "Filing Forms", "Modification Guidance"]
  },
  {
    id: 4,
    category: "Family Law",
    title: "Name Change (Adult)",
    description: "Legal name change documents for adults including court petition and supporting forms",
    price: 79,
    duration: "10-15 minutes", 
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Name Change Petition", "Affidavit", "Court Filing Guide", "Publication Requirements"]
  },
  {
    id: 5,
    category: "Family Law",
    title: "Name Change (Minor)",
    description: "Legal name change documents for minors with parental consent requirements",
    price: 89,
    duration: "15-20 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Minor Name Change Petition", "Parental Consent Forms", "Court Filing Guide", "Guardian Documentation"]
  },
  {
    id: 6,
    category: "Family Law",
    title: "Simple Adoption Paperwork",
    description: "Step-by-step guidance for non-complex adoption cases and required documentation",
    price: 249,
    duration: "45-60 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Heart",
    features: ["Adoption Petition", "Home Study Guide", "Consent Forms", "Court Filing Instructions"]
  },
  {
    id: 7,
    category: "Family Law",
    title: "Domestic Partnership Registration",
    description: "Register domestic partnership or civil union with state-specific forms",
    price: 69,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "Heart",
    features: ["Partnership Application", "Affidavit of Relationship", "Filing Instructions", "Certificate Request"]
  },
  {
    id: 8,
    category: "Family Law",
    title: "Protection Order Forms",
    description: "Restraining order forms for non-emergency domestic situations",
    price: 159,
    duration: "25-30 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Shield",
    features: ["Protection Order Petition", "Incident Documentation", "Service Instructions", "Safety Planning"]
  },

  // Criminal Record / Expungement Services
  {
    id: 9,
    category: "Criminal Record / Expungement",
    title: "Expungement Petition",
    description: "Clear your criminal record with proper expungement paperwork",
    price: 199,
    duration: "30-35 minutes",
    complexity: "Complex",
    popular: true,
    icon: "Shield",
    features: ["Expungement Petition", "Supporting Affidavits", "Court Filing Package", "Background Check"]
  },
  {
    id: 10,
    category: "Criminal Record / Expungement",
    title: "Traffic Ticket Dispute",
    description: "Challenge traffic violations with proper dispute letters and forms",
    price: 39,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Dispute Letter Template", "Evidence Checklist", "Court Appearance Guide", "Fine Reduction Forms"]
  },
  {
    id: 11,
    category: "Criminal Record / Expungement",
    title: "Misdemeanor Discharge Filing",
    description: "File for discharge or dismissal of minor misdemeanor charges",
    price: 149,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "Shield",
    features: ["Discharge Petition", "Compliance Documentation", "Court Filing Guide", "Follow-up Instructions"]
  },
  {
    id: 12,
    category: "Criminal Record / Expungement",
    title: "Certificate of Rehabilitation",
    description: "Apply for certificate of rehabilitation or pardon petition",
    price: 299,
    duration: "40-50 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Award",
    features: ["Rehabilitation Application", "Character References", "Documentation Package", "Filing Instructions"]
  },
  {
    id: 13,
    category: "Criminal Record / Expungement",
    title: "Background Check Request",
    description: "Official background check forms and record request documentation",
    price: 29,
    duration: "5-10 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Record Request Forms", "Identity Verification", "Fee Payment Guide", "Processing Timeline"]
  },

  // Business & Corporate Services
  {
    id: 14,
    category: "Business & Corporate",
    title: "LLC Formation",
    description: "Form your Limited Liability Company with all required state documentation",
    price: 149,
    duration: "25-30 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "Building",
    features: ["Articles of Organization", "Operating Agreement", "EIN Application", "State Filing Guide"]
  },
  {
    id: 15,
    category: "Business & Corporate",
    title: "DBA Registration", 
    description: "Register your 'Doing Business As' name for sole proprietorships and partnerships",
    price: 49,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Building",
    features: ["DBA Application", "Publication Affidavit", "Filing Instructions", "Renewal Reminders"]
  },
  {
    id: 16,
    category: "Business & Corporate",
    title: "Simple Contracts",
    description: "Create NDAs, freelance agreements, and service contracts",
    price: 89,
    duration: "15-25 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "FileText",
    features: ["NDA Templates", "Freelance Agreements", "Service Contracts", "Terms & Conditions"]
  },
  {
    id: 17,
    category: "Business & Corporate",
    title: "Business License Application",
    description: "Apply for business licenses and permits with state-specific guidance",
    price: 79,
    duration: "15-20 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "Building",
    features: ["License Applications", "Permit Forms", "Requirements Checklist", "Renewal Tracking"]
  },
  {
    id: 18,
    category: "Business & Corporate",
    title: "EIN / Tax ID Application",
    description: "Get your Employer Identification Number with IRS forms preparation",
    price: 29,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Building",
    features: ["IRS Form SS-4", "Application Guide", "Processing Instructions", "Confirmation Tracking"]
  },
  {
    id: 19,
    category: "Business & Corporate",
    title: "LLC Operating Agreement",
    description: "Comprehensive operating agreement for your LLC with customizable terms",
    price: 129,
    duration: "30-40 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Building",
    features: ["Operating Agreement Template", "Member Rights", "Management Structure", "Dissolution Procedures"]
  },
  {
    id: 20,
    category: "Business & Corporate",
    title: "Partnership Agreement",
    description: "Create partnership agreements with guided instructions and templates",
    price: 149,
    duration: "35-45 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Users",
    features: ["Partnership Agreement", "Profit Sharing Terms", "Decision Making Process", "Exit Procedures"]
  },

  // Real Estate / Property Services
  {
    id: 21,
    category: "Real Estate / Property",
    title: "Lease Agreement",
    description: "Comprehensive lease agreements for landlords and tenants",
    price: 69,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "Building",
    features: ["Residential Lease", "Commercial Lease", "Terms & Conditions", "State-Specific Clauses"]
  },
  {
    id: 22,
    category: "Real Estate / Property",
    title: "Eviction Notice Templates",
    description: "State-compliant eviction notices and related documentation",
    price: 89,
    duration: "15-20 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Pay or Quit Notice", "Cure or Quit Notice", "Unconditional Quit", "Court Filing Guide"]
  },
  {
    id: 23,
    category: "Real Estate / Property",
    title: "Rent Increase Notice",
    description: "Proper rent increase and late payment notice forms",
    price: 39,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Rent Increase Notice", "Late Payment Notice", "Timeline Requirements", "Tenant Rights Info"]
  },
  {
    id: 24,
    category: "Real Estate / Property",
    title: "Property Transfer Forms",
    description: "Quitclaim deeds, warranty deeds, and property transfer documentation",
    price: 129,
    duration: "25-30 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Building",
    features: ["Quitclaim Deed", "Warranty Deed", "Transfer Documentation", "Recording Instructions"]
  },
  {
    id: 25,
    category: "Real Estate / Property",
    title: "Easement Forms",
    description: "Easement and right-of-way documentation and agreements",
    price: 149,
    duration: "30-35 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Building",
    features: ["Easement Agreement", "Right-of-Way Forms", "Property Survey Guide", "Recording Process"]
  },
  {
    id: 26,
    category: "Real Estate / Property",
    title: "Landlord Tenant Letters",
    description: "Communication letters for repairs, warnings, and notices",
    price: 29,
    duration: "5-10 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Repair Request Letters", "Warning Notices", "Move-out Instructions", "Security Deposit Info"]
  },

  // Wills, Estates & Probate Services
  {
    id: 27,
    category: "Wills, Estates & Probate",
    title: "Simple Will",
    description: "Basic will document with standard provisions for asset distribution",
    price: 79,
    duration: "15-20 minutes",
    complexity: "Simple", 
    popular: true,
    icon: "FileText",
    features: ["Last Will & Testament", "Witness Requirements", "Notarization Guide", "Storage Instructions"]
  },
  {
    id: 28,
    category: "Wills, Estates & Probate",
    title: "Living Will",
    description: "Advance healthcare directives and living will documentation",
    price: 69,
    duration: "15-20 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Heart",
    features: ["Living Will Form", "Healthcare Directives", "Medical Power of Attorney", "HIPAA Authorization"]
  },
  {
    id: 29,
    category: "Wills, Estates & Probate",
    title: "Power of Attorney",
    description: "Grant someone authority to handle your financial and legal matters",
    price: 89,
    duration: "15-20 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Shield",
    features: ["Financial POA", "Healthcare POA", "Durable POA Options", "Revocation Forms"]
  },
  {
    id: 30,
    category: "Wills, Estates & Probate",
    title: "Small Estate Affidavit",
    description: "Simplified probate process for small estates under statutory limits",
    price: 99,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Estate Affidavit", "Asset Inventory", "Heir Documentation", "Court Filing Guide"]
  },
  {
    id: 31,
    category: "Wills, Estates & Probate",
    title: "Guardianship Forms",
    description: "Basic guardianship or conservatorship forms with guidance",
    price: 199,
    duration: "35-45 minutes",
    complexity: "Complex",
    popular: false,
    icon: "Shield",
    features: ["Guardianship Petition", "Conservatorship Forms", "Care Plans", "Court Procedures"]
  },
  {
    id: 32,
    category: "Wills, Estates & Probate",
    title: "Beneficiary Designation",
    description: "Guidance for beneficiary designations on accounts and policies",
    price: 39,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "Users",
    features: ["Beneficiary Forms", "Contingent Beneficiaries", "Account Updates", "Review Checklist"]
  },

  // Civil & Consumer Law Services
  {
    id: 33,
    category: "Civil & Consumer Law",
    title: "Small Claims Filing",
    description: "File small claims cases with proper documentation and guidance",
    price: 89,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: true,
    icon: "Scale",
    features: ["Claim Filing Forms", "Evidence Preparation", "Service Instructions", "Court Appearance Guide"]
  },
  {
    id: 34,
    category: "Civil & Consumer Law",
    title: "Debt Collection Demand",
    description: "Professional demand letters for debt collection and payment disputes",
    price: 49,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Demand Letter Templates", "Payment Plans", "Collection Timeline", "Legal Action Notice"]
  },
  {
    id: 35,
    category: "Civil & Consumer Law",
    title: "Contract Dispute Letters",
    description: "Address contract disputes with professional correspondence",
    price: 69,
    duration: "15-20 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Dispute Letters", "Breach Documentation", "Resolution Proposals", "Legal Action Warning"]
  },
  {
    id: 36,
    category: "Civil & Consumer Law",
    title: "Tenant Complaint Forms",
    description: "Habitability complaints and tenant rights documentation",
    price: 59,
    duration: "15-20 minutes",
    complexity: "Simple",
    popular: false,
    icon: "Building",
    features: ["Complaint Forms", "Habitability Issues", "Repair Requests", "Code Violation Reports"]
  },
  {
    id: 37,
    category: "Civil & Consumer Law",
    title: "Consumer Complaint Letters",
    description: "Refund requests, warranty claims, and consumer protection letters",
    price: 39,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Refund Request Letters", "Warranty Claims", "Consumer Rights", "Agency Complaints"]
  },

  // Immigration & Personal Forms Services
  {
    id: 38,
    category: "Immigration & Personal Forms",
    title: "Travel Consent for Minors",
    description: "Authorization forms for minors traveling without both parents",
    price: 49,
    duration: "10-15 minutes",
    complexity: "Simple",
    popular: true,
    icon: "Users",
    features: ["Travel Consent Form", "Notarization Guide", "Required Documents", "Border Requirements"]
  },
  {
    id: 39,
    category: "Immigration & Personal Forms",
    title: "Affidavits & Sworn Statements",
    description: "Personal and financial affidavits for various legal purposes",
    price: 59,
    duration: "15-20 minutes",
    complexity: "Simple",
    popular: false,
    icon: "FileText",
    features: ["Affidavit Templates", "Sworn Statements", "Notarization Requirements", "Legal Uses Guide"]
  },
  {
    id: 40,
    category: "Immigration & Personal Forms",
    title: "Immigration Document Checklist",
    description: "Non-legal guidance for immigration document preparation assistance",
    price: 79,
    duration: "20-25 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Document Checklists", "Form Preparation", "Filing Requirements", "Timeline Guidance"]
  },
  {
    id: 41,
    category: "Immigration & Personal Forms",
    title: "Visa Renewal Preparation",
    description: "Self-service forms and guidance for visa renewal documentation",
    price: 99,
    duration: "25-30 minutes",
    complexity: "Moderate",
    popular: false,
    icon: "FileText",
    features: ["Renewal Applications", "Supporting Documents", "Filing Procedures", "Timeline Planning"]
  }
];

export const pricingPlans = [
  {
    name: "Pay Per Form",
    price: "Variable",
    description: "Pay only for what you need",
    features: [
      "Individual form pricing",
      "Instant download",
      "Basic filing instructions",
      "Email support",
      "30-day access to forms"
    ],
    buttonText: "Browse Forms",
    popular: false
  },
  {
    name: "Monthly Unlimited",
    price: "$19/month",
    description: "Perfect for ongoing legal needs",
    features: [
      "Unlimited form access",
      "All premium templates",
      "Priority email support", 
      "Video tutorials",
      "Document storage",
      "Filing deadline reminders"
    ],
    buttonText: "Start Free Trial",
    popular: true
  },
  {
    name: "Annual Unlimited",
    price: "$149/year",
    description: "Best value for comprehensive access",
    features: [
      "Everything in Monthly",
      "Save over 35%",
      "Email support",
      "Document review service",
      "State-specific guidance",
      "Premium legal resources"
    ],
    buttonText: "Get Started",
    popular: false
  }
];

export const faqData = [
  {
    question: "Is FormForgePro a law firm?",
    answer: "No, FormForgePro is not a law firm and we do not provide legal advice. We are a legal document preparation service that helps you complete legal forms through guided questionnaires. Our service is designed to help you prepare legal documents, but we cannot provide legal advice or represent you in legal matters."
  },
  {
    question: "Are the forms state-specific?",
    answer: "Yes, all our forms are tailored to meet the specific requirements of your state. When you begin a form, you'll select your state and we'll provide the correct forms and filing instructions for your jurisdiction."
  },
  {
    question: "How long does it take to complete a form?",
    answer: "Most forms can be completed in 10-30 minutes, depending on complexity. Simple forms like name changes typically take 10-15 minutes, while more complex forms like divorce or LLC formation may take 25-30 minutes."
  },
  {
    question: "What happens after I complete my forms?",
    answer: "After completing your forms, you'll receive: (1) Your completed legal documents in PDF format, (2) Step-by-step filing instructions specific to your state, (3) Information about required fees and deadlines, (4) Access to customer support for questions about the filing process."
  },
  {
    question: "Can I modify my forms after completion?",
    answer: "Yes, you can access and modify your forms for 30 days after completion (or unlimited with a subscription). If you need to make changes after this period, you may need to complete the form again."
  },
  {
    question: "Do you offer refunds?",
    answer: "We offer a 30-day money-back guarantee. If you're not satisfied with your purchase, contact our support team within 30 days for a full refund."
  },
  {
    question: "What if I have questions while filling out forms?",
    answer: "Our forms include helpful tooltips and explanations throughout the process. Additionally, subscribers have access to email support for additional guidance."
  },
  {
    question: "Are my documents secure?",
    answer: "Yes, we use bank-level encryption to protect your personal information. Your documents are stored securely and are only accessible by you. We do not share your information with third parties."
  }
];

export const testimonials = [
  {
    name: "Sarah Johnson",
    location: "Austin, TX",
    service: "LLC Formation",
    rating: 5,
    text: "FormForgePro made starting my business so easy! I was dreading the paperwork, but their step-by-step process walked me through everything. Saved me thousands in attorney fees.",
    image: "https://images.unsplash.com/photo-1494790108755-2616b612b47c?w=150&h=150&fit=crop&crop=face"
  },
  {
    name: "Michael Chen", 
    location: "Portland, OR",
    service: "Divorce Forms",
    rating: 5,
    text: "Going through a divorce is hard enough without complicated paperwork. FormForgePro simplified everything and helped me understand exactly what I needed to file.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face"
  },
  {
    name: "Jennifer Martinez",
    location: "Miami, FL", 
    service: "Child Custody",
    rating: 5,
    text: "The child custody forms were exactly what I needed. Clear instructions and everything was accepted by the court on the first try. Highly recommend!",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop&crop=face"
  }
];

export const questionnaireSample = {
  divorce: [
    {
      id: 1,
      question: "What is your full legal name?",
      type: "text",
      required: true,
      help: "Enter your name exactly as it appears on official documents"
    },
    {
      id: 2,
      question: "What is your spouse's full legal name?",
      type: "text", 
      required: true,
      help: "Enter your spouse's name exactly as it appears on official documents"
    },
    {
      id: 3,
      question: "In which state will you file for divorce?",
      type: "select",
      required: true,
      options: ["Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia"],
      help: "Select the state where you or your spouse currently resides"
    },
    {
      id: 4,
      question: "Do you and your spouse have minor children together?",
      type: "radio",
      required: true,
      options: ["Yes", "No"],
      help: "Children under 18 years of age"
    },
    {
      id: 5,
      question: "What is the primary reason for the divorce?",
      type: "radio",
      required: true,
      options: ["Irreconcilable differences", "Adultery", "Abandonment", "Substance abuse", "Other"],
      help: "Select the legal ground for divorce in your state"
    }
  ]
};

export const companyInfo = {
  name: "FormForgePro",
  tagline: "DIY Legal Guidance — No Lawyer Needed",
  description: "Simplifying legal document preparation with guided, step-by-step forms. Get the legal documents you need without the complexity or high costs.",
  email: "support@formforgepro.com",

  founded: "2023",
  customersServed: "10,000+"
};